import { render, staticRenderFns } from "./EndorsementCard.vue?vue&type=template&id=75c3b42b&scoped=true"
import script from "./EndorsementCard.vue?vue&type=script&lang=js"
export * from "./EndorsementCard.vue?vue&type=script&lang=js"
import style0 from "./EndorsementCard.vue?vue&type=style&index=0&id=75c3b42b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c3b42b",
  null
  
)

export default component.exports